import React from "react";
import { node, string } from "prop-types";
import { Col } from "../Grid";
import Link from "../Link";

const Title = ({ href, children }) => (
	<div className="tile-block__title">
		<Link href={href} className="tile-block__title-link">
			{children}
		</Link>
	</div>
);

Title.propTypes = {
	href: string.isRequired,
	children: node.isRequired,
};

const Description = ({ children }) => <div className="tile-block__description">{children}</div>;
Description.propTypes = {
	children: node.isRequired,
};

const TileBlockBody = ({ children }) => (
	<Col auto className="tile-block__body">
		{children}
	</Col>
);

TileBlockBody.propTypes = {
	children: node.isRequired,
};

TileBlockBody.Title = Title;
TileBlockBody.Description = Description;

export default TileBlockBody;
